import './hampshirehe1/style';
import FormStructure from './hampshirehe1/form_structure';

export default FormStructure;